export const filterByLabel = <Option = unknown>(
  options: Option[] | readonly Option[] = [],
  search: string = "",
): Option[] => {
  if (!search) {
    return [...options];
  }

  const normalizedSearch = search.toLowerCase().replace(/\s+/g, "");

  return options.filter(option => {
    let labelToSearch = "";

    if (
      typeof option === "object" &&
      // eslint-disable-next-line sonarjs/different-types-comparison -- Disabled for plugin version update. Fix when possible
      option !== null &&
      "label" in option &&
      typeof option.label === "string"
    ) {
      labelToSearch = option.label;
    } else if (
      typeof option === "object" &&
      // eslint-disable-next-line sonarjs/different-types-comparison -- Disabled for plugin version update. Fix when possible
      option !== null &&
      "textLabel" in option &&
      typeof option.textLabel === "string"
    ) {
      labelToSearch = option.textLabel;
    }

    const textToSearch = labelToSearch.toLowerCase().replace(/\s+/g, "");
    return textToSearch.includes(normalizedSearch);
  });
};
